const actionNames = [
  'approve',
  'reject',
  'terminated',
  'reassign',
  'consult',
  'worksForMe',
  'doesNotWorksForMe',
  'extendEndDate',
  'conditionalCertifiy',
  'doesNotBelongToMe',
  'decommission',
  'edit',
];

const extractActionStates = (nodeData, actionName) => {
  const action = nodeData?.tracker?.actions?.[actionName];

  return {
    isSelected: action?.isSelected || null,
    isLoading: action?.isLoading || null,
    isDisabled: action?.isDisabled || null,
  };
};

const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const getActionStates = (nodeData) =>
  actionNames.reduce((acc, actionName) => {
    const { isSelected, isLoading, isDisabled } = extractActionStates(
      nodeData,
      actionName
    );

    acc[`is${capitalize(actionName)}`] = isSelected;
    acc[`is${capitalize(actionName)}Loading`] = isLoading;
    acc[`is${capitalize(actionName)}Disabled`] = isDisabled;

    return acc;
  }, {});

export default getActionStates;
